var _circle, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDevicesEmptyState = function SvgDevicesEmptyState(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 452,
    height: 280,
    viewBox: "0 0 452 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.42,
    cx: 225.829,
    cy: 137.558,
    r: 137.558,
    fill: "#C5CEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6357_352116)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6357_352116)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.687,
    y: 34,
    width: 181.731,
    height: 181.731,
    rx: 14.6361,
    transform: "rotate(15 264.687 34)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.785,
    y: 73.1797,
    width: 60.804,
    height: 7.68786,
    rx: 3.84393,
    transform: "rotate(15 316.785 73.1797)",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.147,
    y: 94.5527,
    width: 25.8591,
    height: 7.68786,
    rx: 3.84393,
    transform: "rotate(15 329.147 94.5527)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 322.74,
    cy: 168.418,
    rx: 18.5207,
    ry: 5.94062,
    transform: "rotate(15 322.74 168.418)",
    fill: "#E0E9F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.424,
    y: 120.674,
    width: 26.558,
    height: 46.1271,
    rx: 13.279,
    transform: "rotate(15 321.424 120.674)",
    fill: "#BFCBD7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.479,
    y: 123.49,
    width: 23.0636,
    height: 41.2349,
    rx: 11.5318,
    transform: "rotate(15 322.479 123.49)",
    fill: "#DEE5EE",
    stroke: "#A6B1BD",
    strokeWidth: 0.698896
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.028,
    y: 127.159,
    width: 18.1713,
    height: 23.7625,
    rx: 9.08565,
    transform: "rotate(15 324.028 127.159)",
    fill: "#222433"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.329,
    y: 130.402,
    width: 13.9779,
    height: 14.6768,
    rx: 6.98896,
    transform: "rotate(15 325.329 130.402)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.969,
    y: 135.719,
    width: 2.79558,
    height: 2.79558,
    rx: 1.39779,
    transform: "rotate(15 328.969 135.719)",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.499,
    y: 131.439,
    width: 4.19338,
    height: 4.19338,
    rx: 2.09669,
    transform: "rotate(15 326.499 131.439)",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.69,
    y: 186.748,
    width: 48.5639,
    height: 17.0754,
    rx: 8.5377,
    transform: "rotate(15 292.69 186.748)",
    fill: "#212121",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.2,
    cy: 197.599,
    r: 2.74426,
    transform: "rotate(15 300.2 197.599)",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.357 200.537C311.191 201.159 310.935 201.666 310.589 202.058C310.243 202.451 309.842 202.717 309.385 202.858C308.928 202.999 308.448 203.002 307.946 202.867C307.443 202.732 307.029 202.49 306.704 202.14C306.379 201.789 306.164 201.358 306.061 200.845C305.958 200.332 305.99 199.765 306.156 199.144C306.323 198.522 306.579 198.015 306.924 197.623C307.27 197.231 307.671 196.964 308.128 196.823C308.585 196.683 309.065 196.68 309.568 196.814C310.07 196.949 310.484 197.191 310.81 197.542C311.135 197.892 311.349 198.324 311.452 198.836C311.556 199.349 311.524 199.916 311.357 200.537ZM310.667 200.352C310.804 199.842 310.834 199.389 310.757 198.992C310.682 198.596 310.524 198.269 310.283 198.011C310.044 197.754 309.746 197.577 309.389 197.482C309.032 197.386 308.685 197.39 308.347 197.492C308.011 197.596 307.711 197.8 307.446 198.105C307.183 198.411 306.983 198.819 306.847 199.329C306.71 199.839 306.679 200.292 306.754 200.688C306.83 201.085 306.988 201.412 307.228 201.669C307.469 201.927 307.768 202.104 308.125 202.2C308.481 202.295 308.828 202.291 309.164 202.188C309.502 202.085 309.802 201.881 310.065 201.576C310.33 201.27 310.53 200.863 310.667 200.352ZM313.067 201.304L312.355 203.962L311.676 203.78L312.86 199.361L313.516 199.537L313.331 200.228L313.388 200.243C313.552 200.046 313.757 199.908 314.005 199.829C314.253 199.747 314.544 199.751 314.877 199.84C315.176 199.92 315.422 200.052 315.613 200.235C315.805 200.416 315.93 200.647 315.989 200.927C316.048 201.206 316.027 201.534 315.926 201.91L315.174 204.717L314.495 204.535L315.235 201.774C315.328 201.427 315.31 201.132 315.182 200.89C315.054 200.646 314.833 200.482 314.518 200.398C314.302 200.34 314.095 200.335 313.899 200.383C313.705 200.432 313.535 200.533 313.389 200.687C313.243 200.841 313.136 201.047 313.067 201.304ZM318.672 199.34L317.093 205.232L316.414 205.05L317.993 199.158L318.672 199.34ZM318.337 205.565L319.521 201.146L320.2 201.328L319.016 205.747L318.337 205.565ZM320.063 200.502C319.931 200.467 319.829 200.391 319.757 200.275C319.687 200.16 319.669 200.039 319.703 199.912C319.737 199.786 319.813 199.69 319.931 199.625C320.051 199.561 320.178 199.546 320.31 199.582C320.442 199.617 320.543 199.693 320.613 199.808C320.685 199.924 320.704 200.045 320.67 200.171C320.636 200.298 320.559 200.394 320.439 200.458C320.321 200.523 320.196 200.538 320.063 200.502ZM321.65 203.604L320.938 206.262L320.259 206.08L321.443 201.661L322.099 201.837L321.914 202.527L321.972 202.543C322.135 202.346 322.341 202.208 322.588 202.128C322.836 202.047 323.127 202.051 323.461 202.14C323.76 202.22 324.005 202.352 324.197 202.535C324.389 202.716 324.514 202.947 324.572 203.227C324.631 203.506 324.61 203.834 324.51 204.21L323.757 207.017L323.078 206.835L323.818 204.074C323.911 203.727 323.894 203.432 323.765 203.19C323.638 202.946 323.416 202.782 323.102 202.698C322.885 202.64 322.679 202.635 322.483 202.683C322.289 202.732 322.119 202.833 321.973 202.987C321.827 203.141 321.719 203.347 321.65 203.604ZM326.826 207.938C326.4 207.824 326.058 207.632 325.8 207.361C325.544 207.089 325.378 206.761 325.302 206.377C325.228 205.991 325.252 205.572 325.374 205.119C325.495 204.667 325.684 204.29 325.942 203.989C326.201 203.687 326.506 203.478 326.855 203.364C327.207 203.249 327.582 203.245 327.981 203.351C328.211 203.413 328.428 203.512 328.632 203.649C328.836 203.786 329.007 203.965 329.144 204.187C329.283 204.407 329.369 204.673 329.403 204.984C329.436 205.295 329.398 205.657 329.288 206.07L329.211 206.357L325.804 205.445L325.962 204.858L328.677 205.585C328.744 205.336 328.754 205.1 328.707 204.878C328.661 204.656 328.563 204.464 328.411 204.302C328.261 204.141 328.063 204.027 327.818 203.961C327.547 203.889 327.295 203.893 327.062 203.975C326.831 204.054 326.634 204.187 326.471 204.371C326.309 204.556 326.195 204.77 326.13 205.014L326.025 205.405C325.935 205.739 325.917 206.037 325.97 206.3C326.025 206.561 326.14 206.78 326.315 206.957C326.49 207.131 326.715 207.255 326.989 207.328C327.168 207.376 327.335 207.394 327.493 207.383C327.652 207.37 327.798 207.327 327.931 207.254C328.064 207.179 328.18 207.072 328.279 206.934L328.886 207.294C328.757 207.498 328.588 207.662 328.38 207.787C328.173 207.911 327.936 207.987 327.671 208.017C327.407 208.045 327.125 208.018 326.826 207.938Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 264.902,
    y: 34.3734,
    width: 181.121,
    height: 181.121,
    rx: 14.3311,
    transform: "rotate(15 264.902 34.3734)",
    stroke: "#E0E0E0",
    strokeOpacity: 0.8,
    strokeWidth: 0.609836
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6357_352116)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 81.0352,
    width: 181.731,
    height: 181.731,
    rx: 14.6361,
    transform: "rotate(-15 12 81.0352)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3734,
    y: 81.2508,
    width: 181.121,
    height: 181.121,
    rx: 14.3311,
    transform: "rotate(-15 12.3734 81.2508)",
    stroke: "#E0E0E0",
    strokeOpacity: 0.8,
    strokeWidth: 0.609836
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.7081,
    y: 88.916,
    width: 60.804,
    height: 7.68786,
    rx: 3.84393,
    transform: "rotate(-15 76.7081 88.916)",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.1003,
    y: 101.245,
    width: 25.8591,
    height: 7.68786,
    rx: 3.84393,
    transform: "rotate(-15 98.1003 101.245)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.485,
    cy: 168.418,
    rx: 18.5207,
    ry: 5.94062,
    transform: "rotate(-15 129.485 168.418)",
    fill: "#E0E9F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.473,
    y: 127.728,
    width: 26.558,
    height: 46.1271,
    rx: 13.279,
    transform: "rotate(-15 104.473 127.728)",
    fill: "#BFCBD7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.794,
    y: 129.64,
    width: 23.0636,
    height: 41.2349,
    rx: 11.5318,
    transform: "rotate(-15 106.794 129.64)",
    fill: "#DEE5EE",
    stroke: "#A6B1BD",
    strokeWidth: 0.698896
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.971,
    y: 132.044,
    width: 18.1713,
    height: 23.7625,
    rx: 9.08565,
    transform: "rotate(-15 109.971 132.044)",
    fill: "#222433"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.72,
    y: 134.201,
    width: 13.9779,
    height: 14.6768,
    rx: 6.98896,
    transform: "rotate(-15 112.72 134.201)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.53,
    y: 136.985,
    width: 2.79558,
    height: 2.79558,
    rx: 1.39779,
    transform: "rotate(-15 118.53 136.985)",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.25,
    y: 134.515,
    width: 4.19338,
    height: 4.19338,
    rx: 2.09669,
    transform: "rotate(-15 114.25 134.515)",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.626,
    y: 199.316,
    width: 48.5639,
    height: 17.0754,
    rx: 8.5377,
    transform: "rotate(-15 112.626 199.316)",
    fill: "#212121",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.555,
    cy: 204.959,
    r: 2.74426,
    transform: "rotate(-15 124.555 204.959)",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.687 201.925C135.853 202.547 135.885 203.114 135.782 203.626C135.679 204.139 135.464 204.571 135.139 204.921C134.813 205.271 134.399 205.514 133.897 205.648C133.395 205.783 132.915 205.78 132.458 205.639C132.001 205.499 131.599 205.232 131.254 204.84C130.908 204.447 130.652 203.94 130.485 203.319C130.319 202.697 130.287 202.13 130.39 201.618C130.494 201.105 130.708 200.673 131.033 200.323C131.359 199.973 131.773 199.73 132.275 199.596C132.778 199.461 133.257 199.464 133.714 199.605C134.171 199.745 134.573 200.012 134.918 200.404C135.264 200.797 135.52 201.304 135.687 201.925ZM134.996 202.11C134.86 201.6 134.659 201.192 134.394 200.887C134.131 200.581 133.831 200.377 133.493 200.274C133.157 200.171 132.811 200.167 132.454 200.263C132.097 200.359 131.798 200.535 131.557 200.793C131.318 201.051 131.16 201.378 131.083 201.774C131.008 202.17 131.039 202.624 131.176 203.134C131.313 203.644 131.512 204.052 131.775 204.358C132.04 204.663 132.34 204.867 132.676 204.97C133.014 205.073 133.361 205.076 133.718 204.981C134.075 204.885 134.373 204.709 134.612 204.452C134.854 204.194 135.012 203.867 135.086 203.47C135.163 203.074 135.133 202.62 134.996 202.11ZM137.55 201.734L138.262 204.392L137.584 204.574L136.4 200.155L137.055 199.98L137.24 200.67L137.298 200.655C137.341 200.403 137.45 200.18 137.625 199.987C137.799 199.793 138.053 199.651 138.386 199.561C138.686 199.481 138.964 199.472 139.221 199.535C139.478 199.596 139.702 199.733 139.893 199.947C140.083 200.159 140.229 200.453 140.329 200.829L141.082 203.637L140.403 203.819L139.663 201.057C139.57 200.71 139.407 200.464 139.175 200.318C138.942 200.171 138.669 200.139 138.354 200.224C138.137 200.282 137.956 200.381 137.811 200.52C137.667 200.66 137.571 200.832 137.521 201.039C137.472 201.245 137.481 201.477 137.55 201.734ZM141.423 197.231L143.001 203.123L142.322 203.304L140.744 197.413L141.423 197.231ZM144.245 202.789L143.061 198.371L143.74 198.189L144.924 202.607L144.245 202.789ZM143.209 197.542C143.076 197.577 142.95 197.563 142.83 197.498C142.712 197.433 142.636 197.337 142.602 197.211C142.568 197.084 142.586 196.963 142.656 196.848C142.728 196.732 142.83 196.657 142.962 196.621C143.094 196.586 143.22 196.6 143.338 196.665C143.458 196.73 143.535 196.825 143.569 196.952C143.603 197.078 143.584 197.2 143.512 197.315C143.442 197.431 143.341 197.506 143.209 197.542ZM146.134 199.434L146.846 202.092L146.167 202.274L144.983 197.856L145.639 197.68L145.824 198.37L145.882 198.355C145.925 198.103 146.034 197.88 146.208 197.688C146.382 197.493 146.636 197.351 146.97 197.261C147.269 197.181 147.547 197.173 147.805 197.235C148.061 197.296 148.285 197.433 148.476 197.647C148.667 197.859 148.812 198.153 148.913 198.529L149.665 201.337L148.986 201.519L148.246 198.757C148.153 198.41 147.991 198.164 147.759 198.018C147.526 197.871 147.252 197.839 146.938 197.924C146.721 197.982 146.54 198.081 146.394 198.22C146.251 198.36 146.154 198.532 146.105 198.739C146.055 198.945 146.065 199.177 146.134 199.434ZM152.783 200.6C152.357 200.714 151.965 200.719 151.606 200.613C151.248 200.506 150.94 200.305 150.683 200.01C150.426 199.713 150.237 199.338 150.116 198.885C149.995 198.433 149.97 198.012 150.043 197.622C150.117 197.23 150.276 196.898 150.522 196.624C150.768 196.349 151.091 196.157 151.49 196.05C151.72 195.989 151.958 195.966 152.203 195.983C152.448 195.999 152.685 196.069 152.916 196.192C153.146 196.314 153.353 196.501 153.538 196.753C153.723 197.006 153.87 197.339 153.981 197.751L154.058 198.039L150.652 198.951L150.494 198.364L153.21 197.637C153.143 197.387 153.034 197.178 152.882 197.009C152.732 196.84 152.55 196.723 152.338 196.659C152.127 196.594 151.899 196.594 151.653 196.66C151.383 196.733 151.167 196.862 151.006 197.05C150.845 197.234 150.741 197.447 150.693 197.688C150.644 197.93 150.653 198.172 150.718 198.416L150.823 198.807C150.912 199.14 151.045 199.408 151.223 199.609C151.401 199.808 151.61 199.94 151.85 200.005C152.089 200.069 152.346 200.064 152.62 199.99C152.798 199.942 152.953 199.874 153.083 199.786C153.215 199.695 153.32 199.585 153.398 199.455C153.476 199.323 153.523 199.173 153.539 199.004L154.245 199.012C154.235 199.253 154.172 199.48 154.054 199.692C153.936 199.903 153.769 200.087 153.555 200.245C153.34 200.402 153.082 200.52 152.783 200.6Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6357_352116)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 34,
    width: 207.974,
    height: 207.974,
    rx: 16.7496,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.349,
    y: 34.3489,
    width: 207.276,
    height: 207.276,
    rx: 16.4006,
    stroke: "#E0E0E0",
    strokeOpacity: 0.8,
    strokeWidth: 0.6979
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.195,
    y: 61.8779,
    width: 69.5844,
    height: 8.79803,
    rx: 4.39901,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.19,
    y: 81.8428,
    width: 29.5934,
    height: 8.79803,
    rx: 4.39901,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.987,
    cy: 165.392,
    rx: 21.1953,
    ry: 6.79848,
    fill: "#E0E9F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.391,
    y: 113.004,
    width: 30.3932,
    height: 52.7882,
    rx: 15.1966,
    fill: "#BFCBD7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.39,
    y: 115.803,
    width: 26.3941,
    height: 47.1894,
    rx: 13.197,
    fill: "#DEE5EE",
    stroke: "#A6B1BD",
    strokeWidth: 0.799821
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.189,
    y: 119.402,
    width: 20.7953,
    height: 27.1939,
    rx: 10.3977,
    fill: "#222433"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.589,
    y: 122.602,
    width: 15.9964,
    height: 16.7962,
    rx: 7.99821,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.188,
    y: 127.401,
    width: 3.19928,
    height: 3.19928,
    rx: 1.59964,
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.189,
    y: 123.401,
    width: 4.79893,
    height: 4.79893,
    rx: 2.39946,
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.576,
    y: 194.555,
    width: 54.8223,
    height: 19.5412,
    rx: 9.7706,
    fill: "#212121",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.091,
    cy: 204.325,
    r: 3.14055,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.918 203.835C222.918 204.571 222.785 205.207 222.519 205.744C222.253 206.28 221.888 206.694 221.425 206.984C220.961 207.275 220.432 207.421 219.837 207.421C219.241 207.421 218.712 207.275 218.248 206.984C217.785 206.694 217.42 206.28 217.154 205.744C216.888 205.207 216.755 204.571 216.755 203.835C216.755 203.099 216.888 202.463 217.154 201.926C217.42 201.39 217.785 200.977 218.248 200.686C218.712 200.395 219.241 200.25 219.837 200.25C220.432 200.25 220.961 200.395 221.425 200.686C221.888 200.977 222.253 201.39 222.519 201.926C222.785 202.463 222.918 203.099 222.918 203.835ZM222.1 203.835C222.1 203.231 221.999 202.721 221.796 202.305C221.596 201.889 221.325 201.574 220.982 201.361C220.641 201.147 220.259 201.04 219.837 201.04C219.414 201.04 219.031 201.147 218.688 201.361C218.347 201.574 218.076 201.889 217.873 202.305C217.673 202.721 217.573 203.231 217.573 203.835C217.573 204.439 217.673 204.95 217.873 205.365C218.076 205.781 218.347 206.096 218.688 206.31C219.031 206.523 219.414 206.63 219.837 206.63C220.259 206.63 220.641 206.523 220.982 206.31C221.325 206.096 221.596 205.781 221.796 205.365C221.999 204.95 222.1 204.439 222.1 203.835ZM225.034 204.176V207.325H224.23V202.09H225.007V202.908H225.075C225.198 202.642 225.384 202.429 225.634 202.267C225.884 202.104 226.207 202.022 226.602 202.022C226.957 202.022 227.267 202.095 227.533 202.24C227.798 202.383 228.005 202.601 228.153 202.894C228.301 203.185 228.374 203.553 228.374 203.999V207.325H227.57V204.053C227.57 203.642 227.463 203.322 227.25 203.092C227.036 202.86 226.743 202.744 226.37 202.744C226.114 202.744 225.884 202.8 225.682 202.911C225.482 203.023 225.324 203.185 225.208 203.399C225.092 203.612 225.034 203.871 225.034 204.176ZM230.649 200.345V207.325H229.844V200.345H230.649ZM232.122 207.325V202.09H232.926V207.325H232.122ZM232.531 201.217C232.374 201.217 232.239 201.164 232.125 201.057C232.014 200.95 231.958 200.822 231.958 200.672C231.958 200.522 232.014 200.394 232.125 200.287C232.239 200.18 232.374 200.127 232.531 200.127C232.688 200.127 232.822 200.18 232.933 200.287C233.047 200.394 233.104 200.522 233.104 200.672C233.104 200.822 233.047 200.95 232.933 201.057C232.822 201.164 232.688 201.217 232.531 201.217ZM235.204 204.176V207.325H234.4V202.09H235.177V202.908H235.245C235.368 202.642 235.554 202.429 235.804 202.267C236.054 202.104 236.376 202.022 236.772 202.022C237.126 202.022 237.436 202.095 237.702 202.24C237.968 202.383 238.175 202.601 238.323 202.894C238.47 203.185 238.544 203.553 238.544 203.999V207.325H237.74V204.053C237.74 203.642 237.633 203.322 237.419 203.092C237.206 202.86 236.913 202.744 236.54 202.744C236.283 202.744 236.054 202.8 235.852 202.911C235.652 203.023 235.494 203.185 235.378 203.399C235.262 203.612 235.204 203.871 235.204 204.176ZM242.209 207.434C241.704 207.434 241.269 207.323 240.904 207.1C240.54 206.875 240.259 206.562 240.062 206.16C239.866 205.755 239.769 205.285 239.769 204.748C239.769 204.212 239.866 203.74 240.062 203.331C240.259 202.919 240.534 202.599 240.886 202.369C241.241 202.138 241.654 202.022 242.127 202.022C242.4 202.022 242.669 202.067 242.935 202.158C243.201 202.249 243.443 202.397 243.661 202.601C243.879 202.803 244.053 203.072 244.182 203.406C244.312 203.74 244.377 204.151 244.377 204.639V204.98H240.341V204.285H243.559C243.559 203.99 243.5 203.726 243.381 203.494C243.265 203.262 243.1 203.08 242.884 202.945C242.67 202.811 242.418 202.744 242.127 202.744C241.807 202.744 241.529 202.824 241.295 202.983C241.064 203.14 240.885 203.344 240.76 203.596C240.635 203.849 240.573 204.119 240.573 204.408V204.871C240.573 205.267 240.641 205.602 240.777 205.877C240.916 206.149 241.108 206.357 241.353 206.5C241.599 206.641 241.884 206.712 242.209 206.712C242.42 206.712 242.611 206.682 242.781 206.623C242.954 206.562 243.103 206.471 243.228 206.35C243.353 206.228 243.45 206.075 243.518 205.894L244.295 206.112C244.213 206.375 244.076 206.607 243.882 206.807C243.689 207.005 243.451 207.159 243.167 207.271C242.883 207.38 242.563 207.434 242.209 207.434Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6357_352116",
    x: 202.971,
    y: 30.6795,
    width: 251.934,
    height: 251.934,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3596
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.34005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.336698 0 0 0 0 0.352595 0 0 0 0 0.43208 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6357_352116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6357_352116",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6357_352116",
    x: -2.6801,
    y: 30.6795,
    width: 251.934,
    height: 251.934,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3596
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.34005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.336698 0 0 0 0 0.352595 0 0 0 0 0.43208 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6357_352116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6357_352116",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6357_352116",
    x: 105.2,
    y: 30.2,
    width: 241.574,
    height: 241.575,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.336698 0 0 0 0 0.352595 0 0 0 0 0.43208 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6357_352116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6357_352116",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6357_352116"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.687,
    y: 34,
    width: 181.731,
    height: 181.731,
    rx: 14.6361,
    transform: "rotate(15 264.687 34)",
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDevicesEmptyState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "devices-empty-state.8de4090c5b931353c003650fcf117887.svg";